import dashboardRoutes from '../pages/dashboard/routes'
import authRoutes from '../pages/auth/routes'
import twofaRoutes from '../pages/2fa/routes'

/**
 * Application wide routes configuration 
 * 
 * Centralized point of configuring routes 
 */
const allRoutes = [
    ...dashboardRoutes,
    ...authRoutes,
    ...twofaRoutes
]

export default allRoutes